/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  getConnectingTime,
  hasStopOverInfo,
} from '../../shared/helper-utils/appUtils';

function StopOverInfo({ flight }) {
  if (flight.flightlegs.length === 1) {
    return (
      <div className="d-flex flex-column">
        {hasStopOverInfo(flight.flightlegs[0].stopoverinfo) ? (
          <p className="multi-stop-seperator">
            <span className="layover-pointer" />
          </p>
        ) : (
          <p className="non-stop-seperator " />
        )}
        <span className="fs-10 changePlanes" style={{ marginTop: '4px' }}>
          {hasStopOverInfo(flight.flightlegs[0].stopoverinfo) &&
          flight.flightlegs[0].stopoverinfo.length > 1
            ? `1 stop at ${flight.flightlegs[0].stopoverinfo}`
            : 'Non Stop'}
        </span>
      </div>
    );
  }
  let stopoverInfo = `${flight.flightlegs.length - 1} ${
    flight.flightlegs.length > 2 ? 'Stops' : 'Stop'
  } at `;
  flight.flightlegs.forEach((flightLeg, index) => {
    if (index !== flight.flightlegs.length - 1) {
      stopoverInfo += `${flightLeg.destination}, `;
    }
  });
  stopoverInfo = stopoverInfo.slice(0, -2);

  return (
    <div className="d-flex flex-column">
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="layover-tooltip">
            <div className="d-flex flex-column fs-10">
              <span>Change of Planes</span>
              {flight.flightlegs.map(
                (leg, index) =>
                  index !== flight.flightlegs.length - 1 && (
                    <span key={leg.destination}>
                      {leg.destination_name}({leg.destination}) |{' '}
                      {getConnectingTime(
                        leg.arrtime,
                        leg.arrdate,
                        flight.flightlegs[index + 1].deptime,
                        flight.flightlegs[index + 1].depdate,
                      )}{' '}
                      Layover
                    </span>
                  ),
              )}
            </div>
          </Tooltip>
        }
      >
        <div className="cursor-pointer">
          <p className="multi-stop-seperator">
            <span className="layover-pointer" />
          </p>
          <span
            className="fs-10 fw-500 d-inline-block changePlanes"
            style={{ marginTop: '7px' }}
          >
            {stopoverInfo}
          </span>
        </div>
      </OverlayTrigger>
    </div>
  );
}

StopOverInfo.propTypes = {
  flight: PropTypes.object.isRequired,
};

export default StopOverInfo;
